import { render, staticRenderFns } from "./LayoutManage.vue?vue&type=template&id=40f5c3b2"
import script from "./LayoutManage.vue?vue&type=script&lang=js"
export * from "./LayoutManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40f5c3b2')) {
      api.createRecord('40f5c3b2', component.options)
    } else {
      api.reload('40f5c3b2', component.options)
    }
    module.hot.accept("./LayoutManage.vue?vue&type=template&id=40f5c3b2", function () {
      api.rerender('40f5c3b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/_layouts/layout-manage/LayoutManage.vue"
export default component.exports